import Axios from "axios";
import {
    SET_MONEY_REQUISITION_LIST,
    UNSET_MONEY_REQUISITION_LIST,
    SET_EDITING_MONEY_REQUISITION_LIST,
    UNSET_EDITING_MONEY_REQUISITION_LIST,
} from "@/store/mutation-types";

import { saveUpdateEmployeeAdvanceSettles, getEmployeeAdvanceSettlesList, getEmployeeAdvanceSettlesById } from "@/store/api";

const state = {
    getEmployeeAdvanceSettlesList: [],
    getEditingEmployeeAdvanceSettles: null,
};

const getters = {
    getEmployeeAdvanceSettlesList(state) {
        return state.getEmployeeAdvanceSettlesList;
    },
    getEditingEmployeeAdvanceSettles(state) {
        return state.getEditingEmployeeAdvanceSettles;
    },
};

const mutations = {
    [SET_MONEY_REQUISITION_LIST](state, data) {
        state.getEmployeeAdvanceSettlesList = data;
    },
    [UNSET_MONEY_REQUISITION_LIST](state) {
        state.getEmployeeAdvanceSettlesList = [];
    },
    [SET_EDITING_MONEY_REQUISITION_LIST](state, data) {
        state.getEditingEmployeeAdvanceSettles = data;
    },
    [UNSET_EDITING_MONEY_REQUISITION_LIST](state) {
        state.getEditingEmployeeAdvanceSettles = null;
    },
};

const actions = {
    saveUpdateEmployeeAdvanceSettles({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateEmployeeAdvanceSettles, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getEmployeeAdvanceSettlesList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getEmployeeAdvanceSettlesList, { params: data})
                .then(function (response) {
                    commit('SET_MONEY_REQUISITION_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_MONEY_REQUISITION_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getEmployeeAdvanceSettlesById({ commit }, data) {
        const getAssetRegistrationRecordById = `${getEmployeeAdvanceSettlesById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetRegistrationRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
